export const deviceConstants = {
    REQUEST_USER_DEVICES: 'REQUEST_USER_DEVICES',
    UPDATE_DEVICE_LIST: 'UPDATE_DEVICE_LIST',
    GET_DEVICE_DATA: 'GET_DEVICE_DATA',
    UPDATE_DEVICE_DATA: 'UPDATE_DEVICE_DATA',
    
    REQUEST_USER_CLUSTERS: 'REQUEST_USER_CLUSTERS',
    UPDATE_CLUSTER_LIST: 'UPDATE_CLUSTER_LIST',
    FAIL_CLUSTER_LIST: 'FAIL_CLUSTER_LIST',

    REQUEST_CLUSTER_DEVICES: 'REQUEST_CLUSTER_DEVICES',
    UPDATE_CLUSTER_DEVICES: 'UPDATE_CLUSTER_DEVICES',
    FAIL_CLUSTER_DEVICES: 'FAIL_CLUSTER_DEVICES',

    REQUEST_CLUSTER_DEVICE_DATA: 'REQUEST_CLUSTER_DEVICE_DATA',
    UPDATE_CLUSTER_DEVICE_DATA: 'UPDATE_CLUSTER_DEVICE_DATA',
    FAIL_CLUSTER_DEVICE_DATA: 'FAIL_CLUSTER_DEVICE_DATA',

    REQUEST_MORE_CLUSTER_DATA: 'REQUEST_MORE_CLUSTER_DATA',
    UPDATE_MORE_CLUSTER_DATA: 'UPDATE_MORE_CLUSTER_DATA',
    FAIL_MORE_CLUSTER_DATA: 'FAIL_MORE_CLUSTER_DATA',
};